import { useEffect } from "react";
import { GlobalStyle } from "styles/global/GlobalStyle";
import { Router } from "./pages/route/Route";
import { useAuthStore } from "stores/authStore";
import { useErrorStore } from "stores/errorStore";
import AlertModal from "components/molecules/AlertModal";
import { useAlertStore } from "stores/alertStore";
import Toast from "components/molecules/Toast";
import { useToastStore } from "stores/toastStore";

function App() {
  const setToken = useAuthStore((state) => state.setToken);
  const setDeviceId = useAuthStore((state) => state.setDeviceId);
  const setMessage = useAuthStore((state) => state.setMessage);
  const setTimezone = useAuthStore((state) => state.setTimezone);
  const setAppVersion = useAuthStore((state) => state.setAppVersion);
  const setCodepushVersion = useAuthStore((state) => state.setCodepushVersion);
  const setOsType = useAuthStore((state) => state.setOsType);
  const error = useErrorStore((state) => state.error);

  useEffect(() => {
    window.addEventListener("error", (e) => {
      console.error("Global error:", e);
    });
    window.addEventListener("unhandledrejection", (e) => {
      console.error("Unhandled promise rejection:", e);
    });
  }, []);

  useEffect(() => {
    if (error) {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "error",
          errorMsg: "App 오류" + JSON.stringify(error),
        }),
      );
    }
  }, [error]);

  useEffect(() => {
    // 웹뷰 로드 후 RN에 message 전달
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: "ready" }));

    const handleMessage = (event: MessageEvent) => {
      try {
        let data = event.data;
        if (typeof data === "string") {
          data = JSON.parse(event.data);
        }
        if (data) {
          setMessage(data.message);
          if (!!data.token) {
            setToken(data.token); // api token 스토어 저장
            window.ReactNativeWebView?.postMessage(
              JSON.stringify({
                token: data.token,
              }),
            );
          }
          if (!!data.deviceId) {
            setDeviceId(data.deviceId);
            window.ReactNativeWebView?.postMessage(
              JSON.stringify({
                deviceId: data.deviceId,
              }),
            );
          }
          setTimezone(data.timezone);
          setAppVersion(data.appVersion);
          setCodepushVersion(data.codepushVersion);
          setOsType(data.osType);
        }
      } catch (e) {
        console.error("Invalid message data:", e);
      }
    };

    window.addEventListener("message", handleMessage);
    // Android용
    document.addEventListener("message", (event) => {
      handleMessage(event as MessageEvent);
    });

    return () => {
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", (event) => {
        handleMessage(event as MessageEvent);
      });
    };
  }, []);

  return (
    <>
      <GlobalStyle />
      <Router />

      {/* 공통 알럿 */}
      <AlertModal
        isVisible={useAlertStore((state) => state.isVisible)}
        alertStyle={useAlertStore((state) => state.alertStyle)}
        titleMessage={useAlertStore((state) => state.titleMessage)}
        contentComponent={useAlertStore((state) => state.contentComponent)}
        message={useAlertStore((state) => state.message)}
        okButtonText={useAlertStore((state) => state.okButtonText)}
        okButtonStyle={useAlertStore((state) => state.okButtonStyle)}
        textButtonText={useAlertStore((state) => state.textButtonText)}
        cancelButtonText={useAlertStore((state) => state.cancelButtonText)}
        okOnPress={useAlertStore((state) => state.okOnPressWithHide)}
        cancelOnPress={useAlertStore((state) => state.cancelOnPressWithHide)}
        textOnPress={useAlertStore((state) => state.textOnPressWithHide)}
        marginHorizontal={useAlertStore((state) => state.marginHorizontal)}
      />

      {/* 공통 토스트 */}
      <Toast
        isVisible={useToastStore((state) => state.isVisible)}
        message={useToastStore((state) => state.message)}
      />
    </>
  );
}

export default App;
